<template>
  <div class="history-list z-flex">
    <div class="item" v-for="(item, index) in historyList" :key="index" @click="clickImg(item)">
      <el-image class="img" :src="item.img" fit="cover"></el-image>
    </div>
    <el-empty :image="require('@/assets/images/empty-1.png')" description="暂无记录" v-if="historyList.length<=0"></el-empty>
  </div>
</template>

<script>

export default {
  name: "historyCom",
  props: {
    
  },
  data() {
    return {
      historyList:[],
    };
  },
  computed: {
    
  },
  created() {
    
  },
  methods: {
    clickImg(item){
      this.$emit('clickHitoryItem',item);
    },
    // 绘画列表
    getHistoryList(type){
      this.$axios.api.request(
        {
          url: "/api.php/Msgdraw/getDrawList?type=" + type,
          method: "GET",
        },
        (res) => {
          if (res.errno == 0) {
            this.historyList = res.data.list;
          }else{
            this.$message.error(res.message);
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.history-list{
  .item{
    width:calc(25% - 10px);
    margin: 0 10px 10px 0;
    cursor: pointer;
    .img{
      width: 100%;
      height: 85px;
      border-radius: 6px;
      background: url('../assets/images/bg-msk.png') repeat;
    }
  }
  .el-empty{
    width: 100%;
    ::v-deep .el-empty__image{
      width:150px!important;
      opacity: 0.65;
    }
  }
}

</style>
